import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.FORNECEDOR.SET_FILTRO](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},

	[mutationTypes.FORNECEDOR.SET_PAGINACAO](state, paginacao) {
		state.paginacao = paginacao
	},
}
